import { render, staticRenderFns } from "./gravity.vue?vue&type=template&id=1aa52c95&scoped=true&"
import script from "./gravity.vue?vue&type=script&lang=js&"
export * from "./gravity.vue?vue&type=script&lang=js&"
import style0 from "./gravity.vue?vue&type=style&index=0&id=1aa52c95&lang=scss&scoped=true&"
import style1 from "./gravity.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa52c95",
  null
  
)

export default component.exports